import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Formik} from 'formik';

import {deleteStudent} from 'src/redux/student/user';
import Modal from 'shared/components/modal';
import TextArea from 'src/components/text-area';
import FormButton from 'src/components/button';
import Label from 'shared/components/label';

interface Props {
  areYouSureText: string;
  studentId: string;
}

const DeleteAccountModal = ({areYouSureText, studentId}: Props) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <FormButton
        color="negative"
        outline
        onClick={() => setShowModal(true)}
        margin={false}
        buttonName="form-footer delete-confirmation"
        width="100%"
        size="medium"
      >
        Delete Account
      </FormButton>
      <Modal show={showModal} onClose={() => setShowModal(false)} className="delete-account-modal">
        <Modal.TextHeader onClose={() => setShowModal(false)}>
          Delete your account?
        </Modal.TextHeader>
        <Formik
          initialValues={{reason: ''}}
          validate={({reason}) => {
            const errors: {reason?: string} = {};

            if (!reason) {
              errors.reason = 'Please provide a reason.';
            }

            return errors;
          }}
          onSubmit={({reason}) => dispatch(deleteStudent(studentId, reason))}
        >
          {({handleSubmit, errors, getFieldProps}) => (
            <form onSubmit={handleSubmit} autoComplete="off">
              <Modal.Body>
                {areYouSureText}
                <Label>
                  Why would you like to delete your account?
                  <TextArea
                    {...getFieldProps('reason')}
                    error={errors.reason}
                    placeholder="Let us know why"
                    rows={2}
                  />
                </Label>
              </Modal.Body>
              <Modal.Footer
                primaryButton={{
                  type: 'submit',
                  text: 'Delete',
                  'aria-label': 'Delete your account',
                }}
              />
            </form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default DeleteAccountModal;
